export default __webpack_public_path__ + "static/media/timeline.f4519fa4.svg";